/*
 * @Author: ringo
 * @Date: 2021-08-31 15:25:46
 * @LastEditTime: 2023-01-09 15:19:06
 * @LastEditors: ringo
 * @Description:
 * @FilePath: \qifujia-work\qifujia-cms\src\models\index.ts
 */
// 全局状态

type action = {
  payload: object | undefined;
  type: string;
};
const token = localStorage.getItem('token');
let userInfo = {};
let userInfoString = localStorage.getItem('userInfo');
if (userInfoString) {
  userInfo = JSON.parse(userInfoString);
}
let commonEnum = localStorage.getItem('commonEnum');
if (commonEnum) {
  commonEnum = JSON.parse(commonEnum);
}
let enterpriseInfo = localStorage.getItem('enterpriseInfo');
if (enterpriseInfo) {
  enterpriseInfo = JSON.parse(enterpriseInfo);
}

let cognitionEnum = localStorage.getItem('cognitionEnum');
if (cognitionEnum) {
  cognitionEnum = JSON.parse(cognitionEnum);
}
export default {
  namespace: 'index',
  state: {
    is_login: token ? true : false,
    userInfo: userInfo || {},
    commonEnum: commonEnum || {},
    enterpriseInfo: enterpriseInfo || {},
    cognitionEnum: cognitionEnum || {},
  },
  reducers: {
    changeLoginStatus: (state: Object, { payload: status }: action) => {
      console.log(status, '登录状态');
      return {
        ...state,
        is_login: status,
      };
    },
    updateState: (state: Object, { payload, type }: action) => {
      return {
        ...state,
        ...payload,
      };
    },
  },
  effects: {},
  subscriptions: {}, // 订阅数据源
};
